module.exports = __webpack_public_path__ + "static/media/GQL.b0267a70.jpg";